import React from 'react';

import { JackGirderConnection } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';
import { InlineNotification } from '@paragon/notification-tools';

import { addOrUpdateJackGirderConnection } from '../../../../store/actions/insertActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { getCarriedComponentDesignCandidatesForActiveComponentDesign } from '../../../../store/selectors/getJackGirderConnections';
import { inViewOnlyMode } from '../../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import {
  carriedComponentConnectionIsValid,
  CarriedComponentConnectionProperties,
} from './CarriedComponentConnectionProperties';

interface Props {
  readonly carriedComponentConnection: JackGirderConnection;
}

export function CarriedComponentConnectionEdit(props: Props) {
  const { carriedComponentConnection } = props;
  const dispatch = useAppDispatch();
  const carriedComponentDesignCandidates = useAppSelector(getCarriedComponentDesignCandidatesForActiveComponentDesign);
  const carryingComponentDesign = useAppSelector(getActiveComponentDesign);
  const isViewOnly = useAppSelector(inViewOnlyMode);

  if (!carryingComponentDesign) return <InlineNotification type="error">No active component</InlineNotification>;

  return (
    <PropertiesPanel
      title="Carried Component Properties"
      subtitle={carriedComponentConnection.userCreated ? '(user created)' : undefined}
    >
      <CarriedComponentConnectionProperties
        layout="single-column"
        carriedComponentConnection={carriedComponentConnection}
        carryingComponentDesign={carryingComponentDesign}
        carriedComponentDesignCandidates={carriedComponentDesignCandidates}
        onChange={({ carriedComponentConnection: carriedComponentConnectionWithEdits }) => {
          if (
            !carriedComponentConnectionIsValid(
              carriedComponentConnectionWithEdits,
              carryingComponentDesign,
              carriedComponentDesignCandidates,
            )
          ) {
            return;
          }
          dispatch(addOrUpdateJackGirderConnection(carriedComponentConnectionWithEdits, 'update'));
        }}
        disableChangingCarriedComponent
        disabled={isViewOnly}
      />
    </PropertiesPanel>
  );
}
